import { computed, reactive, unref } from 'vue'

// Kept byte-for-byte compatible with Vuelidate 0.7 so migration does not change accepted addresses.
// eslint-disable-next-line no-control-regex
const EMAIL_PATTERN = /^(?:[A-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2,}(?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i

export function required(value) {
    if (typeof value === 'string') return value.trim().length > 0
    if (Array.isArray(value)) return value.length > 0
    return value !== undefined && value !== null
}

export function email(value) {
    return !required(value) || EMAIL_PATTERN.test(value)
}

export function sameAs(expectedValue) {
    return value => value === unref(expectedValue())
}

export function useFormValidation(fields) {
    const touched = reactive(
        Object.keys(fields).reduce((state, fieldName) => ({ ...state, [fieldName]: false }), {})
    )
    const fieldStates = {}

    Object.entries(fields).forEach(([fieldName, field]) => {
        const $invalid = computed(() =>
            field.validators.some(validator => !validator(unref(field.value)))
        )

        fieldStates[fieldName] = reactive({
            $dirty: computed(() => touched[fieldName]),
            $invalid,
            $error: computed(() => touched[fieldName] && $invalid.value),
            $touch() {
                touched[fieldName] = true
            },
            $reset() {
                touched[fieldName] = false
            },
        })
    })

    return reactive({
        ...fieldStates,
        $invalid: computed(() => Object.values(fieldStates).some(field => field.$invalid)),
        $touch() {
            Object.values(fieldStates).forEach(field => field.$touch())
        },
        $reset() {
            Object.values(fieldStates).forEach(field => field.$reset())
        },
    })
}
